import _ from 'axios';
import configs from '../../../conf';
import CmsAPI from '../../common/apis/CmsAPI';
import { Amplify, Auth } from 'aws-amplify';
import TokensStorage from '../common/util/TokensStorage';

const config = configs[process.env.NODE_ENV];

const api = `${config.id}`;

class UserAPI {
  static async signUp(name, email, password) {
    let username = this.generateUUID();
    let emailDomain = email.split('@').pop();

    this.getAwsConfigForDomain(emailDomain)
      .then(domainAwsConfig => {
        return this.setUpUserCompany(domainAwsConfig);
      })
      .then(poolInfo => {
        try {
          // Initialize AWS Amplify
          Amplify.configure({
            Auth: {
              identityPoolId: poolInfo.IdentityPoolId,
              region: poolInfo.Region,
              userPoolId: poolInfo.UserPoolId,

              // Required if userPoolId is defined? https://github.com/aws-amplify/amplify-js/issues/267
              userPoolWebClientId: poolInfo.UserPoolClientAppId,
              storage: TokensStorage,
            },
          });

          localStorage.setItem('configured', JSON.stringify(true));

          Auth.signUp({
            username,
            password,
            attributes: {
              name: name,
              email: email.toLowerCase(),
              'custom:company_id': poolInfo.companyId.toString(),
            },
          }).then(response => {
            const { user } = response;
          });
        } catch (err) {
          console.error('Error signing up:', err);
          return;
        }
      });

    return username;
  }

  static async getAwsConfigForDomain(emailDomain, jwt = null) {
    try {
      let awsConfig = await CmsAPI.getAwsConfigForDomain(emailDomain, jwt);
      return awsConfig.length === 0 ? null : awsConfig[0]; // Similar to firstOrNull()
    } catch (e) {
      return null;
    }
  }

  static async getAwsConfigForUsername(email) {
    try {
      let awsConfig = await CmsAPI.getAwsConfigForUsername(encodeURIComponent(email));
      return awsConfig.length === 0 ? null : awsConfig[0];
    } catch (e) {
      return null;
    }
  }

  static async setUpUserCompany(userPoolInfo) {
    let freemiumUserPool = await this.getDefaultCompanyAwsConfig();
    let isFreemium = userPoolInfo == null || userPoolInfo.companyId == freemiumUserPool.companyId;
    let poolInfo = isFreemium ? freemiumUserPool : userPoolInfo;

    if (!poolInfo) {
      console.error('AwsCompanyConfiguration not found in the response');
      return;
    }

    // Add isFreemium to poolInfo object
    poolInfo.isFreemium = isFreemium;

    return poolInfo;
  }

  static async getDefaultCompanyAwsConfig() {
    let defaultCompanyId = await CmsAPI.defaultCompany('sales');
    let awsConfig = await CmsAPI.getAwsConfigForCompany(defaultCompanyId.result);
    return awsConfig.length === 0 ? null : awsConfig[0];
  }

  static generateUUID() {
    var dt = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16).toLowerCase();
    });

    return uuid;
  }

  static async isEmailAvailable(email) {
    let emailAvailable = await CmsAPI.isEmailAvailable(email.toLowerCase());
    console.log('emailAvailable');
    console.log(emailAvailable);

    return emailAvailable.result;
  }

  static async isEmailRecognized(email) {
    try {
      await CmsAPI.getAwsConfigForUsername(encodeURIComponent(email));
      return true;
    } catch (e) {
      if (e.response.status === 404) return false;
      else throw e;
    }
  }

  static async isDomainRecognized(domainAwsConfig) {
    let companyId = domainAwsConfig == null ? null : domainAwsConfig.companyId;

    if (companyId === null) {
      let response = await CmsAPI.defaultCompany('sales');
      companyId = response.result;

      let vormatsAwsConfig = await this.getAwsConfigForDomain('vormats.com');

      /* For now we want to block new signups via the register page and
             only allow signups from domains we recognize
             It blocks signups if vormats.com is associated to freemium sales but allows
             signups if no email is associated.
             This code can be removed once we open the registration again to general public. */
      let registrationClosed = vormatsAwsConfig.companyId == companyId;
      if (registrationClosed) {
        throw 'Registration with this domain is not allowed.';
      }
    } else {
      return true;
    }
  }
}

export default UserAPI;
